import Vue from 'vue'

export const CraftVue = Vue.extend({
	delimiters: ['${', '}']
})



// WEBPACK FOOTER //
// ./scripts/starters/craft-vue.class.js